import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd/lib/grid';
import './style.scss';
import imgURL from '../../../../../../lib/imgURL';
import { Props } from './typing';
import { ProductsList } from './constants';
import CustomSwitch from '../../../../../../components/CustomSwitch';
import ProfileFooter from '../ProfileFooter';
import { Alert, Space } from 'antd';

const SelectProducts: FC<Props> = (props): JSX.Element => {
  const {
    nextPage,
    prevPage,
    currentStep,
    setCurrentStep,
    merchantProfile,
    setMerchantProfile,
    updateProfileDetails,
  } = props;
  const [productsList, setProductsList]: any = useState([
    ...ProductsList.map((item) => {
      if (merchantProfile.products.includes(item.name)) {
        item.active = true;
      }
      return item;
    }),
  ]);

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (productsList
      .filter((item) => item.active).length > 0) {
        setShowError(false);
      }
  }, [productsList]);

  const callFormSubmit = (step, statusData) => {
    const selectedProducts = productsList
      .filter((item) => item.active)
      .map((item) => item.name);
    if (selectedProducts?.length === 0){
      setShowError(true);
      return false;
    }
    const merchantProfileValue = {
      ...merchantProfile,
      products: selectedProducts,
    };

    updateProfileDetails(step, statusData, merchantProfileValue);
  };

  useEffect(() => {
    const selectedProducts = productsList
      .filter((item) => item.active)
      .map((item) => item.name);
    setMerchantProfile({
      ...merchantProfile,
      products: [...selectedProducts],
    });
  }, [productsList]);

  return (
    <>
      <div className='kyc-select-products'>
        <div className='title'>Select Products to activate</div>
        {showError && <Row className='plural-products'><Col
                span={24}>
          <Space direction='vertical' style={{ width: '100%' }}>
            <Alert
              type='error'
              message='Select at least one Product'
              closable
              banner
              afterClose={() => {setShowError(false);}}
            />
          </Space></Col>
        </Row>}
        <Row className='plural-products'>
          {productsList.map((item) => {
            return (
              <Col
                className='product-column'
                span={9}
                offset={1}
                key={item.name}
              >
                <div className='product'>
                  <div className='detail'>
                    <img src={imgURL[item.iconURL]} alt={item.name} />
                    <div className='product-content'>
                      <div className='name'>{item.name}</div>
                      <div className='label'>{item.label}</div>
                    </div>
                  </div>
                  <div className='product-action'>
                    <CustomSwitch
                      className='product-toggle-switch'
                      onChange={(value: boolean) => {
                        let tempProductList = JSON.parse(
                          JSON.stringify(productsList)
                        );
                        tempProductList = tempProductList.reduce((acc, val) => {
                          if (val.name === item.name) {
                            val.active = value;
                          }
                          return [...acc, val];
                        }, []);
                        setProductsList(tempProductList);
                      }}
                      checked={item.active}
                    />
                    <div className='product-learn-more'>
                      {item.active ? 'Click to Disable' : 'Click to Enable'}
                      {/* <img src={imgURL['learn-more']} onClick={() => {}} /> */}
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
       
        
      </div>
      <ProfileFooter
        nextPage={nextPage}
        prevPage={prevPage}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        saveAction={callFormSubmit}
        enableSave={true}
        enableSaveAndNext={true}
      />
    </>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(SelectProducts);
